import { render, staticRenderFns } from "./CreateNewFileDialog.vue?vue&type=template&id=e0dcef8a&scoped=true"
import script from "./CreateNewFileDialog.vue?vue&type=script&lang=js"
export * from "./CreateNewFileDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateNewFileDialog.vue?vue&type=style&index=0&id=e0dcef8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0dcef8a",
  null
  
)

export default component.exports